// Виды работы в анкете активности — единый список для онбординга
// (StepActivityWork.vue), профиля (ProfileActivity.vue, ProfileHub.vue) и
// запасного расчёта плана (StepPlan.vue). Ключи и смысл подписей совпадают с
// lib/pal.js на сервере (JOBS, JOB_LABELS, JOB_FROM_WORK_TYPE) — менять вместе.
//
// Пять вариантов вместо трёх (с 12.10.2026, docs/activity-pal-v2.md): прежний
// «Смешанный — сижу, но регулярно встаю» считался как лёгкий физический труд
// все восемь часов, а «Активный» смешивал работу стоя и физический труд.
export const JOB_OPTIONS = [
  { id: 'none',        emoji: '🏠', title: 'Дома',                 desc: 'Пенсия, декрет, без работы — день в основном дома' },
  { id: 'desk',        emoji: '💻', title: 'Сидячая',              desc: 'За компьютером или за рулём почти весь день' },
  { id: 'desk_breaks', emoji: '🚶', title: 'Сидячая с перерывами', desc: 'В основном сижу, но регулярно встаю и хожу' },
  { id: 'standing',    emoji: '🧍', title: 'На ногах',             desc: 'Стою или хожу почти весь день без тяжестей: продавец, учитель, повар, медсестра' },
  { id: 'manual',      emoji: '🏗️', title: 'Физический труд',      desc: 'Постоянная нагрузка: стройка, склад, курьер пешком, уборка' },
]
export const JOB_IDS = JOB_OPTIONS.map(o => o.id)

// Короткие подписи для пилюль профиля
export const JOB_SHORT = { none: 'дома', desk: 'сидячая', desk_breaks: 'сидячая с перерывами', standing: 'на ногах', manual: 'физический труд' }

// Старые анкеты знают только work_type — перевод тот же, что на сервере:
// ровно то, что было написано в подписи. «Активный» мог быть и физическим
// трудом — таких просим уточнить (ProfileHub, ProfileActivity).
export const JOB_FROM_WORK_TYPE = { office: 'desk', moderate: 'desk_breaks', heavy: 'standing' }
// Обратно — для старых сборок, которые читают work_type, и для серверной v1
export const WORK_TYPE_FROM_JOB = { none: 'office', desk: 'office', desk_breaks: 'moderate', standing: 'heavy', manual: 'heavy' }
// Старые ответы показываем их же словами, пока человек не переотвечал
export const WORK_TYPE_SHORT = { office: 'сидячий', moderate: 'смешанный', heavy: 'активный' }
// Онбординг до 12.10.2026 хранил в ctx.activity_work_type значения sed/mix/act
export const JOB_FROM_LEGACY_CTX = { sed: 'desk', mix: 'desk_breaks', act: 'standing' }

export function jobOf(pa) {
  if (JOB_IDS.includes(pa?.job)) return pa.job
  return JOB_FROM_WORK_TYPE[pa?.work_type] ?? null
}

// Стиль йоги: v2 на сервере считает MET по стилю (2.3 / 2.7 / 4.0, без
// выбора — 2.5, Compendium 2024). Необязательное поле activities[].style.
export const YOGA_STYLES = [
  { id: 'soft',    label: 'Спокойная: хатха, инь' },
  { id: 'dynamic', label: 'Динамичная: виньяса, аштанга' },
  { id: 'power',   label: 'Силовая: пауэр, горячая' },
]
